// extracted by mini-css-extract-plugin
module.exports = {"root":"regulated-waste-disposal-page_root__peapf"};